export class TransactionEntity {
    id?: number;
    transaction_entity_name?: string;
    transaction_entity_description?: string;
    transaction_entity_category?: string;
    transaction_entity_type?: string;
    transaction_entity_past_tense?: string;
    linked_to_kpi?: boolean;
    position?: number;

    constructor(init?: Partial<TransactionEntity>) {
        Object.assign(this, init);
    }
}